export default __webpack_public_path__ + "static/homepage_US-ab9387f1f89da4d3081d3c258e8a067a.mp4";